
import React, { useState } from 'react';
import borderBottom from "../Resource/layoutMapHeaderBottom.png";
import layoutMap from "../Resource/layoutMap.png";
import { FiPlus } from "react-icons/fi";
import "../Styles/Map.css";

const Map = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target.className === 'Map-overlay') {
      setIsModalOpen(false);
    }
  };

  return (
    <div className='Map-container'>
      <div className='Map-container-heading'>
        The Blueprint of Bliss
        {/* <img src={borderBottom} alt="Border Bottom" className='Map-container-border-bottom' /> */}
      </div>
      <div className='Map-container-content'>
        A thoughtfully planned layout designed for comfort, convenience, and connection.
      </div>

      <div className='Map-container-map-wrapper'>
        <div className='Map-container-map'>
          <FiPlus className='Map-plus-icon' onClick={() => setIsModalOpen(true)} />
        </div>
      </div>

      {isModalOpen && (
        <div className="Map-overlay" onClick={handleOverlayClick}>
          <img src={layoutMap} alt="Full Layout Map" className="Map-fullscreen-image" />
        </div>
      )}
    </div>
  );
};

export default Map;
